module.exports = __webpack_public_path__ + "269f6f8c3ac8c012da0d6520f53875c6.pdf";